/*
 * @Author: your name
 * @Date: 2020-01-09 15:37:05
 * @LastEditTime : 2020-01-10 11:33:55
 * @LastEditors  : Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \source\src\components\onlineMap\model\MapInfo.js
 */
export class MainMapInfo {
    constructor() {
        this.overlayPoint = null;
    }
    


}

/**
 * 地图当前工具
 */
MainMapInfo.currentTool=null;

/**
 * 地图工具类型
 */
export const MapToolType =
{   
    unknown: "unknown",
    
    tool_measureDistance: "tool_measureDistance",

    tool_measureArea: "tool_measureArea",

    tool_drawPoint: "tool_drawPoint",

    tool_drawPolyline: "tool_drawPolyline",

    tool_drawPolygon: "tool_drawPolygon",

    tool_pan: "tool_pan",
    

    //右键菜单
    button_rightClick: "button_rightClick",


    //单击地图
    button_click: "button_click",

    
    

}


